import PageTransition from "../components/PageTransition";
import { LazyBackgroundImage } from "../../shared/components";

const Contact: React.FC = () => {
    return (
        <PageTransition>
        <div className="relative bg-gradient-to-b from-transparent via-transparent to-transparent dark:bg-gray-900 overflow-hidden">
            {/* Decorative Flowers - Lazy Loaded */}
            <LazyBackgroundImage
              webpSrc="/images/optimized/flowers_2.webp"
              fallbackSrc="/images/flowers_2.png"
              className="hidden lg:block absolute inset-y-0 left-0 w-1/2 bg-contain bg-left bg-no-repeat opacity-50"
              rootMargin="200px"
            />
            <LazyBackgroundImage
              webpSrc="/images/optimized/flowers_3.webp"
              fallbackSrc="/images/flowers_3.png"
              className="hidden lg:block absolute inset-y-0 right-0 w-1/2 bg-contain bg-right bg-no-repeat opacity-50"
              rootMargin="200px"
            />

            <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
                <div className="text-center mb-12 animate-slide-up">
                    <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
                        Contact Me
                    </h1>
                    <p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                        I'd love to hear from you. Get in touch today.
                    </p>
                </div>

                {/* Contact Form */}
                <div className="max-w-2xl mx-auto">
                    <div className="bg-gradient-to-br from-peach-25 to-yellow-25 dark:bg-gray-800 rounded-lg p-8 animate-slide-up animation-delay-100 animation-fill-both">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Send me a message</h2>
                        <form className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-4 py-2"
                                />
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-4 py-2"
                                />
                            </div>
                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={4}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-4 py-2"
                                />
                            </div>
                            <button
                                type="submit"
                                className="w-full rounded-md bg-brand-500 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        </PageTransition>
    );
};

export default Contact;
